// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__22rmI","title":"AfterFrontImage_title__2i5BO"};